import React from 'react'
import Slider from './Slider'

import Footer from './Footer'
import Section from './Section'

import img from '../img/gauva.jpg'
import Products from './Products'
import Fertilize from './Fertilize'
import Distrubion from './Distrubion'

const Layout = () => {
  return (
    <div>
      <Slider />
      <div className='heades'>
        <img src={img} />
        <h1>Best Fertilizer Company in Barabanki Uttar Pradesh</h1>
      </div>
      <Section />
      <div className='text-center'><h1>Our Products</h1></div>
      <Products />

      <Fertilize />
      <hr/><br/>
      <Distrubion/>

      <Footer />


    </div>
  )
}

export default Layout